import React, { useEffect, useState } from "react";
import "./MasterDesignConfigure.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../../loading/Loading";
import BackArrowIcon from "../../../../components/icons/BackArrowIcon";
import DownloadIcon from "../../../../components/icons/DownloadIcon";
import PreviewCircleIcon from "../../../../components/icons/PreviewCircleIcon";
import EditIcon from "../../../../components/icons/EditIcon";
import { TemplatesApi } from "../../../../utils/api/Templates";
import ProtectedComponent from "../../../../components/ProtectedComponent";
import NavigationLayout from "../../navigation";
import { clientRoutes } from "../../../../utils/routes";
import SelectDesignModal from "./SelectDesignModal";
import { LocalStorageHelpers } from "../../../../utils/helpers/localstorage.helpers";
import DesignTemplatePreviewRenderer from "../../../../components/image.tool/DesignTemplatePreviewRenderer";
import PropertyStagesDesignData from "../../../../components/image.tool/property.stages.design.data";
import {
  getAgencyLogoUrl,
  getCdnImageUrl,
  getDesignTemplateUrl,
} from "../../../../utils/helpers/common";
import { CommonUtils } from "../../../../utils/helpers/common.utils";
import PreviewModal from "../PreviewModal";

let initialAgencyFontsData = {
  title: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },

  subtitle: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },

  body: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
};

const STEP_MAPPING: any = {
  property_marketing_for_sale: [
    "coming_soon_property_marketing_for_sale",
    "for_sale_listing_property_marketing_for_sale",
    "auction_property_marketing_for_sale",
    "under_offer_property_marketing_for_sale",
    "open_home_property_marketing_for_sale",
  ],
  property_marketing_for_rent: [
    "coming_soon_property_marketing_for_rent",
    "for_rent_listing_property_marketing_for_rent",
    "open_home_property_marketing_for_rent",
    "deposit_taken_property_marketing_for_rent",
  ],
  agent_marketing_for_sale: [
    "sold_agent_marketing_for_sale",
    "review_post_agent_marketing_for_sale",
    "review_recap_agent_marketing_for_sale",
    "under_offer_recap_agent_marketing_for_sale",
    "sold_recap_agent_marketing_for_sale",
  ],
  agent_marketing_for_rent: [
    "leased_agent_marketing_for_rent",
    "review_post_agent_marketing_for_rent",
    "review_recap_agent_marketing_for_rent",
    "leased_recap_agent_marketing_for_rent",
  ],
};

const STEP_LABELS: any = {
  property_marketing_for_sale: "Property marketing for sale",
  property_marketing_for_rent: "Property marketing for rent",
  agent_marketing_for_sale: "Agent marketing for sale",
  agent_marketing_for_rent: "Agent marketing for rent",
};

const chunkArray = (arr: any[], size: number) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size)
    result.push(arr.slice(i, i + size));
  return result;
};

const MasterDesignConfigure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [fullConfig, setFullConfig] = useState<any>(null);
  const [agencyData, setAgencyData] = useState<any>(null);
  const [viewMap, setViewMap] = useState<Record<string, "image" | "story">>({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStageData, setSelectedStageData] = useState<any>(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  const fetchData = async () => {
    setLoading(true);
    const agency = LocalStorageHelpers.getAgencyData();
    setAgencyData(agency);

    const res = await TemplatesApi.getDesignTemplateConfigsById({
      design_template_id: id!,
    });
    if (res?.data?.success) {
      const config = res.data.data?.[0];
      setFullConfig(config);
      setData(config?.design_record_id);

      const initialViews: any = {};
      Object.values(STEP_MAPPING)
        .flat()
        .forEach((slug: any) => {
          initialViews[`${slug}-agent`] = "image";
          initialViews[`${slug}-agency`] = "image";
        });
      setViewMap(initialViews);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (id) fetchData();
  }, [id]);

  const getCanvasImage = (stageKey: string, group: string) => {
    const containerId = `container-${stageKey}-${group}`;
    const element = document.getElementById(containerId);
    if (!element) return null;
    const canvas =
      (element.querySelector("canvas.lower-canvas") as HTMLCanvasElement) ||
      element.querySelector("canvas");
    return canvas ? canvas.toDataURL("image/png") : null;
  };

  const handleDownload = (stageKey: string, group: string) => {
    const dataUrl = getCanvasImage(stageKey, group);
    if (!dataUrl) return;
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${stageKey}-${group}.png`;
    link.click();
  };

  const handleOpenPreview = (stageKey: string, group: string) => {
    const dataUrl = getCanvasImage(stageKey, group);
    if (!dataUrl) return;
    setPreviewImages([dataUrl]);
    setPreviewOpen(true);
  };

  const handleToggleView = (stageKey: string, group: string) => {
    const toggleKey = `${stageKey}-${group}`;
    setViewMap((prev) => ({
      ...prev,
      [toggleKey]: prev[toggleKey] === "story" ? "image" : "story",
    }));
  };

  const handleEditClick = (stageLabel: string, stageSlug: string) => {
    const stageSpecificId =
      fullConfig?.updated_marketing_stages?.[stageSlug]?.design_record_id?._id;

    const currentActiveId =
      stageSpecificId || fullConfig?.design_record_id?._id;

    setSelectedStageData({
      label: stageLabel,
      stageSlug: stageSlug,
      post_type: fullConfig?.post_type || "image_story_post",
      activeDesignId: currentActiveId,
    });
    setIsModalOpen(true);
  };

  const getRendererData = (
    stageKey: string,
    designGroup: "agent" | "agency",
  ) => {
    if (!data || !agencyData || !fullConfig) return null;

    const currentView = viewMap[`${stageKey}-${designGroup}`] || "image";
    const brandData = agencyData?.brand_id;
    const useAgencyOfficeLogo = agencyData?.use_office_logo ?? false;

    let designData = JSON.parse(
      JSON.stringify(
        (PropertyStagesDesignData as any)[stageKey] ||
          PropertyStagesDesignData.coming_soon_property_marketing_for_sale,
      ),
    );

    designData.agency_logo = {
      url: getAgencyLogoUrl(
        brandData && !useAgencyOfficeLogo
          ? brandData.brand_logo
          : agencyData.profile_image_ref,
      ),
      load: true,
    };
    designData.agent_name = CommonUtils.getAgentName(
      agencyData.principal_agent_id,
    );
    designData.agent_profile_image_path = {
      url: getCdnImageUrl(
        agencyData?.principal_agent_id?.profile_image_ref?.storage_key,
      ),
      load: true,
    };
    designData.fonts = initialAgencyFontsData;

    const colors = brandData && !useAgencyOfficeLogo ? brandData : agencyData;
    designData.base_color_primary = {
      hex: colors?.base_color_primary?.hex || "#000",
    };
    designData.base_color_secondary = {
      hex: colors?.base_color_secondary?.hex || "#fff",
    };

    let templateUrl = "";
    let assets = null;

    // --- NEW PRIORITY LOGIC ---

    // 1. Check Priority 1: updated_marketing_stages (Specific Override)
    const stageOverrideRecord =
      fullConfig?.updated_marketing_stages?.[stageKey]?.design_record_id;

    // 2. Check Priority 2: Master Design Flag (data[stageKey])
    const stageInfo = data[stageKey];

    if (stageOverrideRecord) {
      // Priority 1: Agar stage-specific template select kiya gaya hai (e.g. 720)
      templateUrl = getDesignTemplateUrl(
        currentView === "image"
          ? stageOverrideRecord.image_post_master_design_svg_file
              ?.upload_record_id
          : stageOverrideRecord.story_post_master_design_svg_file
              ?.upload_record_id,
      );
      assets =
        currentView === "image"
          ? stageOverrideRecord.image_post_master_design_assets
          : stageOverrideRecord.story_post_master_design_assets;
    } else if (stageInfo?.use_master_design === false) {
      // Priority 2: Agar user ne Master Design false rakha hai aur manual fields use kar raha hai
      const fileField = `${designGroup}_${currentView}_post_master_design_svg_file`;
      const assetField = `${designGroup}_${currentView}_post_design_assets`;
      templateUrl = getDesignTemplateUrl(
        stageInfo?.[fileField]?.upload_record_id,
      );
      assets = stageInfo?.[assetField];
    } else {
      // Priority 3: Default Master Design (e.g. 722)
      // Special logic for Agency Open Home
      const isAgencyOpenHome =
        designGroup === "agency" && stageKey.includes("open_home");

      if (isAgencyOpenHome) {
        const svgField = `agency_open_home_${currentView}_post_master_design_svg_file`;
        const assetField = `agency_open_home_${currentView}_post_master_design_assets`;
        templateUrl = getDesignTemplateUrl(data[svgField]?.upload_record_id);
        assets = data[assetField];
      }

      if (!templateUrl) {
        templateUrl = getDesignTemplateUrl(
          currentView === "image"
            ? data.image_post_master_design_svg_file?.upload_record_id
            : data.story_post_master_design_svg_file?.upload_record_id,
        );
        assets =
          currentView === "image"
            ? data.image_post_master_design_assets
            : data.story_post_master_design_assets;
      }
    }

    designData.template_url = { url: templateUrl, load: true };
    designData.post_type =
      currentView === "image" ? "image_post" : "story_post";

    return { designData, assets, currentView };
  };

  // const getRendererData = (
  //   stageKey: string,
  //   designGroup: "agent" | "agency",
  // ) => {
  //   if (!data || !agencyData) return null;

  //   const currentView = viewMap[`${stageKey}-${designGroup}`] || "image";
  //   const stageInfo = data[stageKey];
  //   const brandData = agencyData?.brand_id;
  //   const useAgencyOfficeLogo = agencyData?.use_office_logo ?? false;

  //   // Build the design data object - Cast PropertyStagesDesignData to any to allow string indexing
  //   let designData = JSON.parse(
  //     JSON.stringify(
  //       (PropertyStagesDesignData as any)[stageKey] ||
  //         PropertyStagesDesignData.coming_soon_property_marketing_for_sale,
  //     ),
  //   );

  //   designData.agency_logo = {
  //     url: getAgencyLogoUrl(
  //       brandData && !useAgencyOfficeLogo
  //         ? brandData.brand_logo
  //         : agencyData.profile_image_ref,
  //     ),
  //     load: true,
  //   };
  //   designData.agent_name = CommonUtils.getAgentName(
  //     agencyData.principal_agent_id,
  //   );
  //   designData.agent_profile_image_path = {
  //     url: getCdnImageUrl(
  //       agencyData?.principal_agent_id?.profile_image_ref?.storage_key,
  //     ),
  //     load: true,
  //   };
  //   designData.fonts = initialAgencyFontsData;

  //   const colors = brandData && !useAgencyOfficeLogo ? brandData : agencyData;
  //   designData.base_color_primary = {
  //     hex: colors?.base_color_primary?.hex || "#000",
  //   };
  //   designData.base_color_secondary = {
  //     hex: colors?.base_color_secondary?.hex || "#fff",
  //   };

  //   let templateUrl = "";
  //   let assets = null;

  //   if (stageInfo?.use_master_design !== false) {
  //     templateUrl = getDesignTemplateUrl(
  //       currentView === "image"
  //         ? data.image_post_master_design_svg_file?.upload_record_id
  //         : data.story_post_master_design_svg_file?.upload_record_id,
  //     );
  //     assets =
  //       currentView === "image"
  //         ? data.image_post_master_design_assets
  //         : data.story_post_master_design_assets;
  //   } else {
  //     const fileField = `${designGroup}_${currentView}_post_master_design_svg_file`;
  //     const assetField = `${designGroup}_${currentView}_post_design_assets`;
  //     templateUrl = getDesignTemplateUrl(
  //       stageInfo?.[fileField]?.upload_record_id,
  //     );
  //     assets = stageInfo?.[assetField];
  //   }

  //   designData.template_url = { url: templateUrl, load: true };
  //   designData.post_type =
  //     currentView === "image" ? "image_post" : "story_post";

  //   return { designData, assets, currentView };
  // };

  const [activeStep, setActiveStep] = useState("property_marketing_for_sale");

  if (loading)
    return (
      <div className="loader-center">
        <Loading />
      </div>
    );

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="master-design-configure-container standard-templates-list-container">
          <div
            className="propertie-view-back-btn"
            onClick={() =>
              navigate(`${clientRoutes.designTemplateTypes}?type=${type}`)
            }
          >
            <div className="back-icon">
              <BackArrowIcon />
            </div>
            <p className="bakc-text-contain">Back</p>
          </div>

          <p className="page-title">Master Design Configuration</p>
          <p className="page-sub-title">
            Manage designs across all marketing stages for the master design
          </p>

          <div className="step-tabs">
            {Object.keys(STEP_MAPPING).map((stepKey) => (
              <div
                key={stepKey}
                className={`tab ${activeStep === stepKey ? "active" : ""}`}
                onClick={() => setActiveStep(stepKey)}
              >
                {STEP_LABELS[stepKey]}
              </div>
            ))}
          </div>

          <div className="step-section">
            <div className="step-title">
              Design setup - {STEP_LABELS[activeStep]} stages
            </div>

            <p className="step-subtitle">
              Review or edit your marketing designs
            </p>

            {chunkArray(STEP_MAPPING[activeStep], 2).map(
              (row: any[], rowIndex) => (
                <div className="stage-row" key={rowIndex}>
                  {row.map((stageKey: string) => {
                    const stage = data?.[stageKey];
                    if (!stage) return null;
                    const isOpenHome = stageKey.includes("open_home");
                    const currentView = viewMap[stageKey] || "image";

                    return (
                      <div
                        className={`stage-block ${isOpenHome ? "full-width-stage" : ""}`}
                        key={stageKey}
                      >
                        <div className="stage-header">
                          <img src="/images/image-placeholder.svg" alt="" />
                          <span>{stage?.stage_label}</span>
                        </div>
                        <div className="designs-split-container">
                          {["agent", "agency"].map((group) => {
                            if (group === "agency") {
                              const isNotOpenHome =
                                !stageKey.includes("open_home");

                              const hasMasterAgencyFile =
                                data
                                  ?.agency_open_home_image_post_master_design_svg_file
                                  ?.upload_record_id ||
                                data
                                  ?.agency_open_home_story_post_master_design_svg_file
                                  ?.upload_record_id;

                              const hasStageAgencyFile =
                                stage?.agency_image_post_master_design_svg_file
                                  ?.upload_record_id ||
                                stage?.agency_story_post_master_design_svg_file
                                  ?.upload_record_id;

                              if (
                                isNotOpenHome ||
                                (!hasMasterAgencyFile && !hasStageAgencyFile)
                              ) {
                                return null;
                              }
                            }

                            const rData = getRendererData(
                              stageKey,
                              group as any,
                            );
                            const currentView =
                              viewMap[`${stageKey}-${group}`] || "image";

                            // CAST: Cast Renderer to any to bypass strict prop checks
                            const Renderer =
                              DesignTemplatePreviewRenderer as any;

                            return (
                              <div
                                className="master-design-template-card-wrapper design-template-card-wrapper design-templates-list-card"
                                key={group}
                              >
                                <div className="template-header-wrapper">
                                  <div className="header-top-row">
                                    <p className="template-name">
                                      {group === "agent" ? "Agent" : "Agency"}{" "}
                                      designs
                                    </p>
                                    <div
                                      className="edit-icon-wrapper"
                                      onClick={() =>
                                        handleEditClick(
                                          stage?.stage_label,
                                          stageKey,
                                        )
                                      }
                                    >
                                      <EditIcon />
                                    </div>
                                  </div>
                                  <p className="template-description">
                                    Verify or customize image and story designs
                                    for {group} posts
                                  </p>
                                </div>
                                <div
                                  className="preview-main-box"
                                  id={`container-${stageKey}-${group}`} // Group zaroori hai unique ID ke liye
                                >
                                  <div
                                    className={
                                      currentView === "image"
                                        ? "image-view-wrapper"
                                        : "story-view-wrapper story-design-template-preview-container"
                                    }
                                  >
                                    {rData && (
                                      <Renderer
                                        key={`${stageKey}-${group}-${currentView}`}
                                        agencyData={agencyData}
                                        brandData={agencyData?.brand_id}
                                        useAgencyOfficeLogo={
                                          agencyData?.use_office_logo
                                        }
                                        designDataFromParent={rData.designData}
                                        canvasWidth={1080}
                                        canvasHeight={
                                          currentView === "image" ? 1080 : 1920
                                        }
                                        designTemplateAssets={rData.assets}
                                        colorsData={rData.designData}
                                      />
                                    )}
                                  </div>
                                  <button
                                    type="button"
                                    className={`view-toggle-btn ${currentView === "image" ? "toggle-to-story" : "toggle-to-image"}`}
                                    onClick={() =>
                                      handleToggleView(stageKey, group)
                                    }
                                  >
                                    <img
                                      src="/images/workspace/image.svg"
                                      alt="Switch"
                                    />
                                  </button>
                                </div>
                                <div className="master-post-footer">
                                  <span className="post-type-label">
                                    {currentView === "image"
                                      ? "Image Post"
                                      : "Story Post"}
                                  </span>
                                  <div className="footer-icons">
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleDownload(stageKey, group)
                                      }
                                    >
                                      <DownloadIcon />
                                    </span>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleOpenPreview(stageKey, group)
                                      }
                                    >
                                      <PreviewCircleIcon />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ),
            )}
          </div>
        </div>
        <SelectDesignModal
          show={isModalOpen}
          onClose={() => fetchData().then(() => setIsModalOpen(false))}
          stageLabel={selectedStageData?.label || ""}
          selectedDesignTemplateStageSlug={selectedStageData?.stageSlug || ""}
          // YAHAN CHANGE HAIN: activeDesignId pass karein
          selectedDesignTemplateId={selectedStageData?.activeDesignId || ""}
          postType={selectedStageData?.post_type || ""}
        />
        <PreviewModal
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          images={previewImages}
        />
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default MasterDesignConfigure;
